import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import { chatBotSaveLog } from 'actions/item';
import MultipleButtons from 'components/chatBot/messageTypes/multipleButtons';


class UpdateShipmentMethodDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            multipleButtons: Object.assign({}, this.props.message, {buttons: []})
        };

        this.buttonsClick = this.buttonsClick.bind(this);

        // this.prepareButtons();
    }

    componentDidMount() {
        this.prepareButtons();
    }

    prepareButtons(){
        let buttons = this.state.multipleButtons.buttons;
        let action = this.props.action;
        if(this.props.message){
            _.each(this.props.message.buttons, (button)=> {
                buttons.push(
                    {
                        name: button.label,
                        text: `<div>${button.label}</div>`,
                        response: [
                            {
                                key: `message_update_${action}_details_${button.action}`,
                                direction: "2",
                                type: "message",
                                text: `${button.responseText}`,
                                hide_waves_timeout: "2500",
                                time_to_show: "1800",
                                pauseConversation: true
                            }
                        ],
                        default_response: `update_${action}_details_response`,
                        action: button.action || undefined,
                        followUpMessage: button.followUpMessage || undefined,
                    }
                );
            });
        }

    }

    buttonsClick(message, button) {
        this.props.onClick(message, button);
    }

    render(){
        return (
            <div>
                <MultipleButtons id={this.props.id} message={this.state.multipleButtons} onClick={this.buttonsClick} />
            </div>
        );
    }
}

const mapStateToProps = ({Session, Item}) => {
    return {
        Session,
        item: Item
    }
};

export default connect(mapStateToProps)(UpdateShipmentMethodDetails);